import { render, staticRenderFns } from "./TaxjarOrders.vue?vue&type=template&id=56b33258&scoped=true"
import script from "./TaxjarOrders.vue?vue&type=script&lang=js"
export * from "./TaxjarOrders.vue?vue&type=script&lang=js"
import style0 from "./TaxjarOrders.vue?vue&type=style&index=0&id=56b33258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b33258",
  null
  
)

export default component.exports